import { render, staticRenderFns } from "./brandPopupWindow.vue?vue&type=template&id=0a1d2ef4"
import script from "./brandPopupWindow.vue?vue&type=script&lang=js"
export * from "./brandPopupWindow.vue?vue&type=script&lang=js"
import style0 from "./brandPopupWindow.vue?vue&type=style&index=0&id=0a1d2ef4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports